<div class="alert alert-warning">
  <div>
    <i class="fa-solid fa-triangle-exclamation fs-2"></i>
    <p
      [innerHTML]="
        'maintenance.banner'
          | transloco
            : {
                start: parsedNotification?.begin,
                end: parsedNotification?.end,
              }
      "
    ></p>
  </div>
</div>
